/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import type {ComponentPropsWithRef, ReactElement} from 'react'

/**
 * @public
 */
export function EqualIcon(props: ComponentPropsWithRef<'svg'>): ReactElement {
  return (
    <svg
      data-sanity-icon="equal"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.5 4.5H3.5V20.5H7.5" stroke="currentColor" strokeWidth={1.2} />
      <path d="M17.5 20.5L21.5 20.5L21.5 4.5L17.5 4.5" stroke="currentColor" strokeWidth={1.2} />
      <path d="M9 10.5H16" stroke="currentColor" strokeWidth={1.2} />
      <path d="M9 14.5H16" stroke="currentColor" strokeWidth={1.2} />
    </svg>
  )
}

export {EqualIcon as default}
